import { Injectable } from '@angular/core';
import { BEWorkflowSteps } from './beWorkflow.model';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class BEWorkflowService {
    private _workflow = [
        {
            step: BEWorkflowSteps.beItinerary,
            valid: false,
            changed: false,
            menuLocked: false,
            disabled: false
        },
        {
            step: BEWorkflowSteps.beVehicleSelection,
            valid: false,
            changed: false,
            menuLocked: false,
            disabled: false
        },
        {
            step: BEWorkflowSteps.beExtras,
            valid: false,
            changed: false,
            menuLocked: false,
            disabled: false
        },
        {
            step: BEWorkflowSteps.beReview,
            valid: false,
            changed: false,
            menuLocked: false,
            disabled: false
        },
        {
            step: BEWorkflowSteps.beConfirmation,
            valid: false,
            changed: false,
            menuLocked: true,
            disabled: false
        }
    ];

    //workflow management variables
    private _currentStep: string;
    private _currentStepMenuLocked: boolean = false;

    public invokeSaveFirst: Subject<string> = new Subject();

    public validateStep(step: string) {
        //if the state is found, set the 'valid' field to true 
        var found = false;
        for (var i = 0; i < this._workflow.length; i++) {
            if (this._workflow[i].step === step) {
                this._workflow[i].changed = false;
                found = this._workflow[i].valid = true;
            }
            else if (found) {
                //invalidate any forms AFTER the one just validated
                this._workflow[i].valid = false;
            }
        }
    }

    public invalidateStep(step: string) {
        //if the step is found, set the 'valid' field to false 
        var found = false;
        for (var i = 0; i < this._workflow.length; i++) {
            if (this._workflow[i].step === step) {
                this._workflow[i].changed = false;
                this._workflow[i].valid = false;
                found = true;
            }
            else if (found) {
                //invalidate any forms AFTER the one just invalidated
                this._workflow[i].valid = false;
            }
            else {
                //validate any forms BEFORE the one just invalidated
                this._workflow[i].valid = true;
            }
        }
    }

    public firstStep(): string {
        //return the first step 
        return (this._workflow.length > 0 ? this._workflow[0].step : "");
    }

    public previousStep(step: string): string {
        //return the step that precedes the given step 
        var stepFound: boolean = false;
        var previousStep: string = "";

        for (var i = 0; i < this._workflow.length; i++) {
            if (this._workflow[i].step === step) {
                stepFound = true;
                break;
            }
            else
                previousStep = this._workflow[i].step;
        }

        return (stepFound ? previousStep : "");
    }

    public nextStep(step: string): string {
        //return the step that follows the given step 
        var stepFound: boolean = false;
        var nextStep: string = "";

        for (var i = 0; i < this._workflow.length; i++) {
            if (this._workflow[i].step === step)
                stepFound = true;
            else if (stepFound) {
                nextStep = this._workflow[i].step;
                break;
            }
        }

        return nextStep;
    }

    public getStepStatus(): any
    {
        var previousStepValid = false;
        var stepDisabled: boolean;

        for (var i = 0; i < this._workflow.length; i++) {
            let item = this._workflow[i];

            if (i == 0)
                previousStepValid = (!this._currentStepMenuLocked || (item.step === this._currentStep));

            if (this._currentStepMenuLocked) {
                stepDisabled = (item.step !== this._currentStep);
            }
            else {
                stepDisabled = (!previousStepValid);

            }
            previousStepValid = previousStepValid && item.valid && !item.changed;

            item.disabled = stepDisabled;
        }

        return this._workflow;
    }

    public setCurrentStep(currentStep: string, unlockMenu = false) {
        var stepMenuLocked: boolean = false;

        if (!unlockMenu) {
            for (var i = 0; i < this._workflow.length; i++) {
                if (this._workflow[i].step === currentStep) {
                    stepMenuLocked = this._workflow[i].menuLocked;
                    break;
                }
            }
        }

        this._currentStep = currentStep;
        this._currentStepMenuLocked = stepMenuLocked;
    }

    public changeStep(step: string, isChanged: boolean) {
        //if the state is found, set the 'changed' field to the given value
        for (var i = 0; i < this._workflow.length; i++) {
            if (this._workflow[i].step === step) {
                this._workflow[i].changed = isChanged;
                break;
            }
        }
    }

    private currentStepIsChanged(): boolean {
        //if the state is found, set the 'changed' field to the given value
        var isChanged = false;
        for (var i = 0; i < this._workflow.length; i++) {
            if (this._workflow[i].step === this._currentStep) {
                isChanged = this._workflow[i].changed;
                break;
            }
        }

        return isChanged;
    }

    public resetSteps() {
        //reset all the steps in the Workflow to be invalid
        this._workflow.forEach(element => {
            element.valid = false;
        });
    }

    public getFirstInvalidStep(step: string, byRefParams: {revisedPath: string, cancelNavigation: boolean}) {
        byRefParams.revisedPath = '';

        if (this._currentStepMenuLocked) {
            byRefParams.revisedPath = this._currentStep;
        }
        else {
            //if all the previous steps are validated, return blank
            //otherwise, return the first invalid step
            var found = false;
            var valid = true;
            for (var i = 0; i < this._workflow.length && !found && valid; i++) {
                let item = this._workflow[i];

                if (item.step === step) {
                    found = true;
                    byRefParams.revisedPath = '';
                }
                else {
                    valid = (item.valid && !item.changed);
                    byRefParams.revisedPath = item.step
                }
            }

            if ((((found) && (step != this._currentStep))
                || ((!found) && (byRefParams.revisedPath != this._currentStep)))
                && (this.currentStepIsChanged())) {

                //the user is trying to navigate using the menu bar, but the current page has pending changes
                //so invoke this class's SaveFirst event (to be picked up by the subscribing beData component (and then passed on to the subscribing page components)
                this.invokeSaveFirst.next(step);
                byRefParams.revisedPath = this._currentStep;
            }
        }

        if (this._currentStep == byRefParams.revisedPath) {
            byRefParams.cancelNavigation = true;
        }
    }
}